import Reflux from 'reflux';
import { AppActions, CategoryActions } from 'actions';
import SteelCompass from 'services/SteelCompass';

const CategoryStore = Reflux.createStore({
  listenables: [CategoryActions],
  data: {
    list: [],
    loading: true
  },
  getInitialState() {
    return this.data;
  },
  init() {},
  initCategories() {
    if (this.data.list.length < 1) {
      this.readCategories();
    }
  },
  loading(loading) {
    this.data = {
      ...this.data,
      loading
    };
    this.trigger(this.data);
  },
  readCategories() {
    this.loading();
    return SteelCompass.request('category', 'read', {}).then(
      list => {
        CategoryActions.readCategoriesComplete(list);
      },
      error => {
        this.loading(false);
        AppActions.genericError(error);
      }
    );
  },
  readCategoriesComplete(list) {
    this.data = {
      ...this.data,
      list: list.map(category => ({
        payload: category.slug,
        id: category.id,
        slug: category.slug,
        label: category.name
      })),
      loading: false
    };
    this.trigger(this.data);
  }
});

export default CategoryStore;



// WEBPACK FOOTER //
// ./src/js/stores/Category.js